<main class="grow" role="content">
  <div class="kt-container-fixed py-8">
    <div class="kt-card unauthorized-card">
      <div class="kt-card-content">
        <div class="unauthorized-icon" aria-hidden="true">
          <i class="ki-filled ki-lock-2"></i>
        </div>
        <h1 class="unauthorized-title">Unauthorized</h1>
        <p class="unauthorized-text">
          Your Microsoft account is authenticated, but it does not have access to FRIDA.
          Please contact support if you believe this is incorrect.
        </p>
      </div>
    </div>
  </div>
</main>
